import { useState } from "react";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import useMarcaEquipamento from "features/equipamento/hooks/useMarcaEquipamento";
import { showSuccess } from "infra/helpers/alerta";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";
import { useDebounce } from "features/shared/useDebouce";
import ModalCadastroMarcaEquipamento from "./ModalCadastroMarcaEquipamento";

export interface SelectMarcaEquipamentoProps<T = any>
  extends SelectBaseAntdProps<T> {}

function SelectMarcaEquipamento({ ...rest }: SelectMarcaEquipamentoProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [search, setSearch] = useState<string>();

  const debouncedSearch = useDebounce(search);

  const { isLoading, data, isFetching, refetch } =
    useMarcaEquipamento(debouncedSearch);

  const handleSuccess = async ({ id, nome }: { id: string; nome: string }) => {
    setIsOpenModal(false);

    setTimeout(() => {
      showSuccess(`Marca de equipamento salva com sucesso`).then(() => {
        refetch();
        rest.onChange?.(id, { value: id, label: nome });
      });
    }, 500);
  };

  const _isLoading = isLoading || isFetching;

  return (
    <>
      {isOpenModal ? (
        <ModalCadastroMarcaEquipamento
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          onSaved={handleSuccess}
        />
      ) : null}

      <SelectBaseAntd
        loading={_isLoading}
        size="large"
        placeholder="Selecione um equipamento"
        searchValue={search}
        showSearch
        onSearch={setSearch}
        optionFilterProp="label"
        options={data?.items.map((item) => ({
          value: item.id,
          label: item.nome,
        }))}
        {...rest}
        notFoundContent={
          !_isLoading ? (
            <Box>
              Nenhuma marca de equipamento encontrada{" "}
              <Button
                isLoading={isLoading}
                leftIcon={<i className="mdi mdi-plus" />}
                size="xs"
                colorScheme="orange"
                onClick={() => setIsOpenModal(true)}
              >
                cadastrar nova
              </Button>
            </Box>
          ) : (
            <Box>Carregando...</Box>
          )
        }
      />
    </>
  );
}

export default SelectMarcaEquipamento;
